/* Terra Decode mobile repairs — 2026-07-31 */
(function () {
  function repairStoryLinks() {
    document
      .querySelectorAll('a[href="/pages/story"], a[href="/pages/terra-decode-story"]')
      .forEach(function (link) {
        link.setAttribute('href', '/pages/our-story');
      });
  }

  function repairOurStoryPage() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path !== '/pages/our-story') return;

    document.body.classList.add('terra-our-story-mobile-fix');

    var content = document.querySelector('.main-page-title + .rte') || document.querySelector('.rte');
    if (!content) return;

    content.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
    content.style.opacity = '1';
    content.style.transform = 'none';
    content.style.overflow = 'visible';
    content.style.maxHeight = 'none';

    content.querySelectorAll('img').forEach(function (image) {
      image.setAttribute('loading', 'eager');
      image.setAttribute('decoding', 'async');
      image.style.display = 'block';
      image.style.visibility = 'visible';
      image.style.opacity = '1';
      image.style.height = 'auto';
      image.style.maxHeight = 'none';

      if (image.dataset && image.dataset.src && !image.getAttribute('src')) {
        image.setAttribute('src', image.dataset.src);
      }
    });

    window.setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 120);
  }

  function applyRepairs() {
    repairStoryLinks();
    repairOurStoryPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRepairs, { once: true });
  } else {
    applyRepairs();
  }

  document.addEventListener('shopify:section:load', applyRepairs);
})();
